import { TRACKING_FORM } from "src/app/shared/defines/tracking.defines";

/** config */
export const config = {
  generalError: {
    name: 'allgemeiner_fehler',
    route: '/allgemeiner_fehler',
    fallbackDeeplinking: {
      url: '/hub',
      disableRefresh: true,
    },
  },
  CenterHub: {
    name: 'hub',
    route: '/hub',
    titleKey: 'centerhub.title.std-headline',
    tracking: TRACKING_FORM.CENTERHUB,
  },
  Confirmation: {
    name: 'resultat',
    route: '/resultat',
    fallbackDeeplinking: {
      url: '/hub',
      disableRefresh: true,
    },
  },
  FormEditor: {
    name: ':id',
    route: '/:id',
  },
};
